<template>

    <ui-view class="view-growers">

        <ui-heading title="Mosselkwekers" icon="fa-building">
            <ui-button color="positive" icon="magicon-plus" route="grower-add">Kweker toevoegen</ui-button>
            <ui-searchbar v-model="search"/>
        </ui-heading>

        <ui-table-panel
            clickable
            v-spinner="loading"
            :placeholder="growers && !growers.items.length"
            :total="$safe('growers.totalCount')"
            :visible="paging.limit"
            @page="switchPage">
            <ui-table-header>
                <ui-th weight="2" field="name" v-model="sort">Naam</ui-th>
                <ui-th weight="3" field="address" v-model="sort">Adres</ui-th>
                <ui-th weight="2" field="phoneNumber" v-model="sort">Telefoonnummer</ui-th>
                <ui-th weight="1" field="postcode" v-model="sort">Postcode</ui-th>
                <ui-th weight="3" field="email" v-model="sort">E-mail adres</ui-th>
                <ui-th weight="2" field="waterInsightsAccessible" v-model="sort">Water inzichten</ui-th>
                <ui-th weight="2" field="shared" v-model="sort">Leveren aan andere kwekers</ui-th>
                <ui-th weight="1"/>
            </ui-table-header>
            <ui-tr v-for="grower in $safe('growers.items')" :key="grower.id" click="edit">
                <td>{{ grower.name }}</td>
                <td>{{ grower.address }}</td>
                <td>{{ grower.phoneNumber }}</td>
                <td>{{ grower.postcode }}</td>
                <td>{{ grower.email }}</td>
                <td>{{ grower.waterInsightsAccessible | bool }}</td>
                <td>{{ grower.shared | bool }}</td>
                <td class="actions" @click.stop>
                    <ui-link
                        icon="magicon-edit"
                        v-tooltip="'Wijzigen'"
                        action="edit"
                        :to="{ name: 'grower-edit', params: { id: grower.id } }" />
                    <ui-link icon="magicon-trash" v-tooltip="'Verwijderen'" @click="deleteGrower(grower.id)" />
                </td>
            </ui-tr>
        </ui-table-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import pagingMixin from 'js-core/js/mixins/paging';
import createQuery from 'js-core/js/apollo/queries/createQuery';

import AllGrowersQuery from 'gql/queries/Growers/AllGrowers.gql';

import GrowerMutations from 'app/mutations/GrowerMutations';

@Component({

    name: 'Growers',
    mixins: [pagingMixin],
    apollo: {
        growers: createQuery(AllGrowersQuery, {

            variables(){

                return {
                    offset: this.paging.offset,
                    limit: this.paging.limit,
                    search: this.search,
                    sortField: this.sort.field,
                    sortDirection: this.sort.direction
                };
            }
        })
    }
})
export default class Growers extends Vue
{
    loading = 0;

    search = this.$persist('search');
    sort = this.$persist('sort', {
        field: 'name',
        direction: 'ASC'
    });

    breadcrumb(){

        return 'Mosselkwekers';
    }

    async deleteGrower(id) {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je deze mosselkweker wilt verwijderen?');
        if(!result) {
            return;
        }

        try {

            await GrowerMutations.delete(id);

            this.$toast.success('De mosselkweker is succesvol verwijderd');
            this.$refetchQuery('growers');
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting grower ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van de mosselkweker');
        }

        this.$overlay.close(overlay);
    }
}

</script>